<template>
  <div>
    <h2>1. まずはテストを受験してみましょう！</h2>
    <h2>2. テスト結果を確認して、苦手な発音を発見しましょう</h2>
    <h2>3. 発音トレーニングページで、問題のあった発音を練習しましょう</h2>
    <h2>
      4. エクササイズと、発音記号の解説動画を何度もみて再度チャレンジ！
    </h2>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 1.2rem;
}
</style>
